import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api, LOGO_URL } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("mhc_admin_token", data.token);
      localStorage.setItem("mhc_admin_email", data.email);
      toast.success("Signed in");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-8">
          <img src={LOGO_URL} className="w-12 h-12 object-contain" alt="MHC" />
          <div>
            <div className="font-heading font-semibold text-slate-900">Melo Hopeful Care</div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-teal-700">The Heart of Home Care</div>
          </div>
        </Link>
        <form onSubmit={submit} className="soft-card space-y-5" data-testid="admin-login-form">
          <div>
            <h1 className="text-2xl font-semibold text-slate-900">Welcome back</h1>
            <p className="text-sm text-slate-500 mt-1">Sign in to the submissions dashboard.</p>
          </div>
          <div>
            <label className="label-field">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" data-testid="al-email" />
          </div>
          <div>
            <label className="label-field">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" data-testid="al-password" />
          </div>
          <button disabled={loading} className="btn-primary w-full" data-testid="al-submit">
            <Lock className="w-4 h-4" /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
